<template>
    <div class="fullcontainer p5bg">
      <MusicIcon v-show="false"/>
        <img class="logo" src="res/p5/logo.png">
        <video ref="video" class="video" src="" poster="" @pause="onPause" @play="onPlay" controls preload>
          您的浏览器不支持 video 标签。
        </video>
      <div class="bottombtn">
        <div v-for="(item,i) in items" :key="i">
          <img :class="{myimg:currentItem==item}" :src="getUrl(item)" @click="onPicClick(item)">
        </div>
      </div>
    </div> 
</template>

<script>
// import { url } from "@/d";
import Back2FirstPage from "./Back2FirstPage";
import MusicIcon, { getExtends } from "./MusicIcon";
import AnimatePlayer from "./AnimatePlayer";

const components = { Back2FirstPage, AnimatePlayer, MusicIcon };
export default {
  data() {
    return {
      items: [
        { name: "1" },
        { name: "2" },
        { name: "3" }
        // { name: "4" },
        // { name: "5" },
        // { name: "6" }
      ],
      currentItem: null
    };
  },

  mounted() {
    let video = this.$refs.video;
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        video.play();
      },
      false
    );

    this.onPicClick(this.items[0]);
  },

  methods: {
    getUrl(item) {
      return `res/p5/${item.name}.jpg`;
    },
    onPicClick(item) {
      let video = this.$refs.video;
      video.src = `res/p5/${item.name}.mp4`;
      video.play();
      this.currentItem = item;
    }
  },

  components,
  extends: getExtends()
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p5bg {
  .logo {
    top: 4%;
    @include horizontalCenterPercent(50%);
  }

  .video {
    position: absolute;
    @include horizontalCenterPercent(96%);
    top: 26%;
  }

  .bottombtn {
    position: absolute;
    top: 70%;
    width: 100%;
    height: 50%;
    display: flex;
    flex-wrap: wrap;

    div {
      width: 33.3%;
      height: 20%;
      position: relative;
      img {
        // position: relative;
        @include horizontalCenterPercent(80%);
      }

      .myimg {
        border-width: 2px;
        border-style: solid;
        border-radius: 8px;
      }
    }
  }
}
</style>
